export default __webpack_public_path__ + "static/scraps-ce68df845b765d5e2566d3b3bdfd50c6.png";